import React, { FC, useCallback } from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import AccountTreeIcon from '@mui/icons-material/AccountTree'
import { Pattern } from '../../app/builder/contexts/PatternContext'
import { useApplicationSuiteContext } from '../../contexts/ApplicationSuiteProvider'
import { Tabs } from '../../layout/MainLayout'

interface PatternCopiedDialogProps {
  pattern: Pattern | null
  onClose: () => void
}

const PatternCopiedDialog: FC<PatternCopiedDialogProps> = ({ pattern, onClose }) => {
  const { setActiveTab } = useApplicationSuiteContext()

  const openInPatternBuilder = useCallback(() => {
    if (!pattern) return
    setActiveTab({ tab: Tabs.PatternBuilder, options: { item: pattern } })
    onClose()
  }, [pattern, setActiveTab, onClose])

  return (
    <Dialog open={!!pattern} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent>
        <Box
          display="flex"
          flexDirection="column"
          gap={2}
          px={2}
          py={2}
          alignItems="center"
          textAlign="center"
        >
          <CheckCircleOutlineIcon sx={{ fontSize: '64px' }} color="success" />
          <Typography variant="h5" fontWeight="bold">
            Pattern copied to your account
          </Typography>
          <Box display="flex" alignItems="center" gap={1}>
            <AccountTreeIcon fontSize="small" color="action" />
            <Typography variant="subtitle1" fontWeight="medium">
              {pattern?.name || 'Unnamed Pattern'}
            </Typography>
          </Box>
          <Typography variant="body2" color="textSecondary">
            You'll find it in the Pattern Builder tab, where you can edit it, backtest it, or create
            alerts from it.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 3, gap: 1 }}>
        <Button onClick={onClose} variant="outlined">
          Keep working
        </Button>
        <Button onClick={openInPatternBuilder} variant="contained">
          Open in Pattern Builder
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default PatternCopiedDialog
